/**
 * Custom Clerk UserProfile page for notification preferences
 */

import { useGetEmailPreferencesQuery, useToggleEmailNotificationsMutation } from '../services/api';
import { useState, useEffect } from 'react';

export default function NotificationsPage() {
  const { data: emailPrefs, isLoading: emailPrefsLoading } = useGetEmailPreferencesQuery();
  const [toggleEmailNotifications, { isLoading: isToggling }] = useToggleEmailNotificationsMutation();
  const [emailEnabled, setEmailEnabled] = useState(false);

  useEffect(() => {
    if (emailPrefs?.data?.email !== undefined) {
      setEmailEnabled(emailPrefs.data.email);
    }
  }, [emailPrefs]);

  const handleToggleEmail = async (enabled: boolean) => {
    setEmailEnabled(enabled);
    try {
      await toggleEmailNotifications(enabled).unwrap();
    } catch (error) {
      console.error('Failed to update email preferences:', error);
      // Revert on error
      setEmailEnabled(!enabled);
    }
  };

  return (
    <div className="space-y-6 p-6">
      <div>
        <h2 className="text-xl font-semibold mb-2">Email Notifications</h2>
        <p className="text-gray-400 text-sm mb-6">
          Configure how you want to be notified about new versions and security updates.
        </p>
      </div>

      {emailPrefsLoading ? (
        <div className="text-sm text-gray-500">Loading preferences...</div>
      ) : (
        <div className="space-y-4">
          <label className="flex items-start space-x-3 cursor-pointer group">
            <input
              type="checkbox"
              checked={emailEnabled}
              onChange={(e) => handleToggleEmail(e.target.checked)}
              disabled={isToggling}
              className="mt-1 w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-0 disabled:opacity-50 cursor-pointer"
            />
            <div className="flex-1">
              <div className="font-medium text-gray-900 dark:text-gray-100">
                Daily Email Digest
              </div>
              <div className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                Receive a daily summary of new software versions and CVEs discovered in the previous day
              </div>
            </div>
          </label>

          {isToggling && (
            <div className="text-sm text-gray-500 italic">
              Updating preferences...
            </div>
          )}
        </div>
      )}

      <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          You can change these preferences at any time. Email notifications are sent daily at 9 AM UTC.
        </p>
      </div>
    </div>
  );
}
